// areaPolygonTools.js — Bespoke draw interactions for AREA polygon rules with
// vertex count constraints.
//
// AREA10: min 3, max 6 anchor points. Auto-commits at 6; allows early commit
//         (double-click / Enter) from vertex 3 onward.

import { DrawRules } from '@armyc2.c5isr.renderer/mil-sym-ts-web';
import Feature from 'ol/Feature';
import { Polygon } from 'ol/geom';
import { registerDrawInteraction } from '../customDrawInteractions';
import { createMultiPointCollector } from './multiPointCollector';
import { PREVIEW_LINE_BLUE_DASHED } from './drawPreviewStyles';

const POLY_STYLE = PREVIEW_LINE_BLUE_DASHED;

/**
 * Capped polygon collector: min `minCount`, max `maxCount` vertices.
 * Auto-commits at maxCount. Early commit via double-click or Enter at >= minCount.
 */
function makeCappedPolygonCollector(map, { minCount, maxCount, onFinish }) {
    return createMultiPointCollector(map, {
        minCount,
        maxCount,
        onFinish,
        // Every vertex here is a plain boundary corner — no tip/rear/width distinction for
        // this DrawRule family — so all stay 'anchor'.
        roleForIndex: () => 'anchor',
        styleResolver: () => POLY_STYLE,
        onSketchUpdate: ({ previewSource, collected3857, cursorCoord3857 }) => {
            const pts = cursorCoord3857 ? [...collected3857, cursorCoord3857] : collected3857;
            if (pts.length >= 2) {
                const ringPts = pts.length >= 3 ? [...pts, pts[0]] : pts;
                const pf = new Feature(new Polygon([ringPts]));
                pf.set('_t', 'poly');
                previewSource.addFeature(pf);
            }
        },
    });
}

// AREA10: min 3, max 6
registerDrawInteraction(DrawRules.AREA10, (map, opts) =>
    makeCappedPolygonCollector(map, { minCount: 3, maxCount: 6, onFinish: opts.onFinish }));

